var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey01Solid = function SvgKey01Solid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M15 2a7 7 0 0 0-6.937 7.94 15 15 0 0 1 .062.514l-.008.01a9 9 0 0 1-.245.25l-5.11 5.11-.037.036a2.8 2.8 0 0 0-.43.51c-.11.178-.19.373-.24.577a2.8 2.8 0 0 0-.055.665v1.82c0 .252 0 .498.017.706.019.229.063.499.2.77a2 2 0 0 0 .875.874c.271.138.541.182.77.201.208.017.454.017.706.017H7a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 .707-.293l1.58-1.579a8 8 0 0 1 .249-.245l.01-.008.045.003c.103.01.244.029.469.06q.463.061.94.062a7 7 0 1 0 0-14m0 6a1 1 0 0 1 .707.293c.196.195.293.45.293.707a1 1 0 1 0 2 0c0-.766-.293-1.536-.879-2.122A3 3 0 0 0 15.001 6a1 1 0 1 0 0 2",
    clipRule: "evenodd"
  })));
};
export default SvgKey01Solid;